import Input from "@/components/ui/Input";
import Select from "@/components/ui/Select";
import {
  GEODESIE_OPTIONS,
  TYPE_ENVIRONNEMENT_OPTIONS,
  QUALITE_ENVIRONNEMENT_OPTIONS,
  MODE_TRANSPORT_OPTIONS,
  QUALITE_DESSERTE_OPTIONS,
  DESSERTE_TRANSPORTS_OPTIONS,
  APPRECIATION_3_OPTIONS,
} from "@/constants/enums";

export default function SectionSituationDetails({ data, onChange }) {
  const val = (field) => {
    return field.split(".").reduce((obj, key) => obj?.[key], data) ?? "";
  };

  return (
    <div className="space-y-6">
      {/* Situation generale */}
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">
        Situation generale
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Select
          label="Position / centre-ville"
          name="situation.geodesie"
          options={GEODESIE_OPTIONS}
          value={val("situation.geodesie")}
          onChange={(e) => onChange("situation.geodesie", e.target.value)}
        />
        <Select
          label="Environnement"
          name="situation.environnement"
          options={TYPE_ENVIRONNEMENT_OPTIONS}
          value={val("situation.environnement")}
          onChange={(e) => onChange("situation.environnement", e.target.value)}
        />
        <Select
          label="Qualite environnement"
          name="situation.qualite_environnement"
          options={QUALITE_ENVIRONNEMENT_OPTIONS}
          value={val("situation.qualite_environnement")}
          onChange={(e) =>
            onChange("situation.qualite_environnement", e.target.value)
          }
        />
      </div>

      {/* Distances et transports */}
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">
        Distances et transports
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Input
          label="Distance commerces (km)"
          name="situation.distance_commerces_km"
          type="number"
          value={val("situation.distance_commerces_km")}
          onChange={(e) =>
            onChange("situation.distance_commerces_km", e.target.value)
          }
        />
        <Input
          label="Distance commerces (min)"
          name="situation.distance_commerces_min"
          type="number"
          value={val("situation.distance_commerces_min")}
          onChange={(e) =>
            onChange("situation.distance_commerces_min", e.target.value)
          }
        />
        <Select
          label="Mode transport commerces"
          name="situation.mode_transport_commerces"
          options={MODE_TRANSPORT_OPTIONS}
          value={val("situation.mode_transport_commerces")}
          onChange={(e) =>
            onChange("situation.mode_transport_commerces", e.target.value)
          }
        />
        <Input
          label="Distance ski (km)"
          name="situation.distance_ski_km"
          type="number"
          value={val("situation.distance_ski_km")}
          onChange={(e) =>
            onChange("situation.distance_ski_km", e.target.value)
          }
        />
        <Input
          label="Distance ski (min)"
          name="situation.distance_ski_min"
          type="number"
          value={val("situation.distance_ski_min")}
          onChange={(e) =>
            onChange("situation.distance_ski_min", e.target.value)
          }
        />
        <Select
          label="Mode transport ski"
          name="situation.mode_transport_ski"
          options={MODE_TRANSPORT_OPTIONS}
          value={val("situation.mode_transport_ski")}
          onChange={(e) =>
            onChange("situation.mode_transport_ski", e.target.value)
          }
        />
      </div>

      {/* Desserte */}
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">
        Desserte
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Qualite de desserte"
          name="situation.qualite_desserte"
          options={QUALITE_DESSERTE_OPTIONS}
          value={val("situation.qualite_desserte")}
          onChange={(e) =>
            onChange("situation.qualite_desserte", e.target.value)
          }
        />
        <Select
          label="Desserte transports en commun"
          name="situation.desserte_transports_commun"
          options={DESSERTE_TRANSPORTS_OPTIONS}
          value={val("situation.desserte_transports_commun")}
          onChange={(e) =>
            onChange("situation.desserte_transports_commun", e.target.value)
          }
        />
      </div>

      {/* Points forts / faibles */}
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">
        Appreciation
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Points forts"
          name="situation.points_forts"
          type="textarea"
          value={val("situation.points_forts")}
          onChange={(e) =>
            onChange("situation.points_forts", e.target.value)
          }
        />
        <Input
          label="Points faibles"
          name="situation.points_faibles"
          type="textarea"
          value={val("situation.points_faibles")}
          onChange={(e) =>
            onChange("situation.points_faibles", e.target.value)
          }
        />
        <Select
          label="Renommee de la commune"
          name="situation.renommee_commune"
          options={APPRECIATION_3_OPTIONS}
          value={val("situation.renommee_commune")}
          onChange={(e) =>
            onChange("situation.renommee_commune", e.target.value)
          }
        />
        <Select
          label="Qualite commodites"
          name="situation.qualite_commodites"
          options={APPRECIATION_3_OPTIONS}
          value={val("situation.qualite_commodites")}
          onChange={(e) =>
            onChange("situation.qualite_commodites", e.target.value)
          }
        />
      </div>

      {/* Texte auto-genere */}
      {data?.situation?.localisation_texte && (
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Localisation (auto-genere)
          </label>
          <textarea
            className="w-full rounded-lg border-slate-300 bg-slate-50 text-sm"
            rows={4}
            value={data.situation.localisation_texte}
            onChange={(e) =>
              onChange("situation.localisation_texte", e.target.value)
            }
          />
        </div>
      )}
    </div>
  );
}
